import {
	ChangeDetectionStrategy,
	Component,
	inject,
	signal,
	OnInit,
} from '@angular/core';
import { IRoutineTemplate } from '@app/pages/settings/interfaces/routine.interfaces';
import { LoadingSpinnerComponent } from '@app/shared/ui-components/loading-spinner/loading-spinner.component';
import { ActivatedRoute } from '@angular/router';
import { NewRightSidebarService } from '@app/layout/new-right-sidebar/services/new-right-sidebar/new-right-sidebar.service';
import { RoutineService } from '@app/pages/settings/routines/services/routines.service';
import { RoutineWorkspaceFormComponent } from '../routine-workspace-form/routine-workspace-form.component';

@Component({
	selector: 'routine-template-workspace',
	imports: [LoadingSpinnerComponent, RoutineWorkspaceFormComponent],
	templateUrl: './routine-template-workspace.component.html',
	styleUrl: './routine-template-workspace.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoutineTemplateWorkspaceComponent implements OnInit {
	private readonly route = inject(ActivatedRoute);
	private readonly newSidebarService = inject(NewRightSidebarService);
	private readonly routineService = inject(RoutineService);
	routineData = signal<IRoutineTemplate | null>(null);

	ngOnInit(): void {
		this.route.params.subscribe(params => {
			if (!params.pk) {
				this.newSidebarService.close();
				return;
			}
			this.loadRoutine(params.pk);
		});
	}

	private loadRoutine(pk: string) {
		this.routineService
			.getRoutineTemplates(pk)
			.subscribe((routine: IRoutineTemplate[]) => this.routineData.set(routine[0]));
	}
}
